import React from 'react';
import { getAllQuizzes } from '../data/quizRegistry';
import { hasCompletedQuiz } from '../utils/resultHistory';

const QuizBadges: React.FC = () => {
  const quizzes = getAllQuizzes();
  const completedCount = quizzes.filter((q) => hasCompletedQuiz(q.id)).length;

  if (completedCount === 0) return null;

  return (
    <div style={{
      width: '100%',
      maxWidth: '500px',
      margin: '16px 0',
      textAlign: 'center',
    }}>
      <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#555', marginBottom: '12px' }}>
        🎖️ 완료 도장판 ({completedCount}/{quizzes.length})
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', flexWrap: 'wrap' }}>
        {quizzes.map((quiz) => {
          const done = hasCompletedQuiz(quiz.id);
          return (
            <div
              key={quiz.id}
              style={{
                width: '56px',
                height: '56px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '28px',
                background: done
                  ? `linear-gradient(135deg, ${quiz.gradient[0]}, ${quiz.gradient[1]})`
                  : '#e0e0e0',
                opacity: done ? 1 : 0.4,
                boxShadow: done ? '0 2px 8px rgba(0,0,0,0.15)' : 'none',
                transition: 'all 0.3s',
              }}
              title={quiz.title}
            >
              {quiz.icon}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuizBadges;
